import { action, Action } from 'easy-peasy';

export interface ITeamModel {
    bid: string | undefined;
    name: string | undefined;
    setBid: Action<ITeamModel, string | undefined>;
    setName: Action<ITeamModel, string | undefined>;

    setTeamInfo: Action<ITeamModel, any>;
}

export const teamModel: ITeamModel = {
    bid: '',
    name: '',
    setBid: action((state, bid) => {
        state.bid = bid;
    }),
    setName: action((state, name) => {
        state.name = name;
    }),
    setTeamInfo: action((state, info) => {
        state.bid = info?.bid || undefined;
        state.name = info?.name || undefined;
    }),
};
